export default "__VITE_ASSET__C51Kxi6m__"